<template>
	<footer id="footnote">
		<div class="trademark">
			<span class="version">
				<infoDialogBox
					title=""
					containerClass="about-app"
					:activatorText="appTitle + ' ' + appVersion"
					:showIcon="false"
				>
					<div class="about-app-content">
						<div class="logo-container">
							<template v-if="appLogoFileName">
								<img :src="require('@/assets/imgs/' + appLogoFileName)"
									class="logo"
									:alt="appTitle"
								/>
							</template>
							<template v-else>
								<h1>{{appTitle}}</h1>
							</template>
						</div>
						<div class="about-app-details">
							<div class="quavo-sub">
								<a href="https://www.quavo.com" target="_" title="visit Quavo.com">
									<img src="../assets/imgs/qvo-logo-color.svg" alt="Quavo, Inc." class="qvo-logo" />
								</a>
							</div>
							<div class="version-details" v-if="appReleaseNotesPath">
								version {{ appVersion }}
								<v-btn
									text
									:href="appReleaseNotesPath + appVersion"
									target="_"
								>
									See Release Notes
								</v-btn>
							</div>
							<!-- legal agreements here -->
						</div>

					</div>
				</infoDialogBox>
			</span>
			&copy; {{ new Date().getFullYear() }}, Quavo, Inc.
		</div>
	</footer>
</template>

<script>

	export default {
		name: 'footnote',
		props: {
			appLogoFileName: {
				// The full name and file type: example1.png / example2.svg / example3.jpg
				type: String,
				required: false
			},
			appReleaseNotesPath: {
				// The URL path to the live release notes. We'll dynamically add the version number to the end.
				// appReleaseNotesPath + appVersion must resolve to a destination when combined
				type: String,
				required: false
			}
		},
		computed: {
			appVersion() {
				return this.$store.getters.appVersion;
			},
			appTitle() {
				return process.env.VUE_APP_TITLE;
			},
		},
	}
</script>

<style lang="scss" scoped>
#footnote {
	grid-area: footnote;
	display: flex;
	flex-direction: column-reverse;
	padding: 2em;
	color: #fff;

	.trademark {
		font-size: 0.9em;

		.version {
			margin-right: 0.5em;
		}

		.more-info-button {
			color: $qvo-color-brand-teal;

			&:hover,
			&:active {
				color: $qvo-color-brand-teal-lite;
			}
		}
	}
}

.about-app {
	background-image: radial-gradient(circle at 15% 10%, #fff 70%, $qvo-color-util-neutral-lite 59%);
}

.about-app-content {
	display: flex column;
	justify-content: center;
	width: 20em;

	.logo-container img {
		width: 100%;
		margin-bottom: -2em;
	}
	.quavo-sub {
		display: flex;
		justify-content: center;

		&::before {
			content: "by";
			font-size: 0.8em;
			margin-left: -2em;
			margin-right: 0.5em;
		}
	}
	.qvo-logo {
		width: 8em;
	}
	.version-details {
		display: flex;
		margin-top: 3em;
		align-items: center;
		justify-content: center;

		.v-btn {
			margin-right: -1em;
		}
	}
}

@media only screen and (min-width: 900px) {
	#footnote {
		.version {
			display: block;
		}
	}
}
</style>
